module.exports = __webpack_public_path__ + "static/media/Pic-0589.a3a362a3.jpg";